var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import i18next from 'i18next';
import translations from './assets/locale/messages_en.json';
import * as localeData from '@wix/locale-dataset-data/resources/translations/messages_en.json';
import i18nextXHRBackend from 'i18next-xhr-backend';
import { I18nextProvider } from 'react-i18next';
export default function i18n(_a) {
    var locale = _a.locale;
    return i18next.init({
        ns: ['invoice-view', 'locale-data'],
        defaultNS: 'invoice-view',
        lng: locale,
        fallbackLng: 'en',
        keySeparator: '$',
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        resources: {
            en: {
                'invoice-view': translations,
                'locale-data': localeData,
            },
        },
    });
}
export function i18nXHR(_a) {
    var locale = _a.locale, _b = _a.baseUrl, baseUrl = _b === void 0 ? '' : _b;
    var defaultNS = '';
    var filePath = function (ns, lng) { return function (base) { return "".concat(base, "assets/locale/").concat(ns, "/messages_").concat(lng, ".json"); }; };
    return i18next
        .createInstance()
        .use(i18nextXHRBackend)
        .init({
        lng: locale,
        fallbackLng: 'en',
        keySeparator: '$',
        defaultNS: defaultNS,
        ns: ['invoice-view', defaultNS, 'locale-data'],
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: function (_a, _b) {
                var lng = _a[0];
                var ns = _b[0];
                return filePath(ns, lng)(baseUrl);
            },
            crossDomain: true,
        },
    });
}
export function i18nLocal(_a) {
    var locale = _a.locale;
    var defaultNS = 'invoice-view';
    var languageBundle = {};
    try {
        languageBundle = require("./assets/locale/messages_".concat(locale, ".json"));
    }
    catch (_b) { }
    var instance = i18n({ locale: locale });
    if (locale !== 'en') {
        instance.addResourceBundle(locale, defaultNS, languageBundle, true);
        instance.addResourceBundle(locale, 'locale-data', localeData, true);
    }
    return instance;
}
export var withProvider = function (TranslatedComponent) {
    return function (props) {
        var i18nInstance = React.useMemo(function () { return i18nLocal({ locale: props.locale }); }, [props.locale]);
        return (React.createElement(I18nextProvider, { i18n: i18nInstance },
            React.createElement(TranslatedComponent, __assign({}, props))));
    };
};
//# sourceMappingURL=i18n.js.map